import app from '../helpers/auth';
import firebase from 'firebase/compat/app';
import 'firebase/compat/messaging';

let messaging = null;

if (typeof window !== 'undefined') {
  try {
    // Use the v8 compat messaging API
    messaging = firebase.messaging();

    // Register service worker
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker
        .register('/firebase-messaging-sw.js')
        .then((registration) => {
          console.log('✅ Service Worker registered:', registration);
        })
        .catch((error) => {
          console.error('❌ Service Worker registration failed:', error);
        });
    }
  } catch (error) {
    console.error('Error initializing Firebase messaging:', error);
  }
}

export { app, messaging };
export default app;
